import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@driftt/tide'
import EditIcon from 'images/mini_edit_category_icon.svg'
import DeleteIcon from 'images/mini_delete_category_icon.svg'

import cx from 'classnames'

const CHEVRON_DOWN = 'chevron-down-bold'
const CHEVRON_RIGHT = 'chevron-right-bold'

const EditCategoryButtons = ({ onEditIconClick, onDeleteIconClick, shouldShowDelete }) => (
  <div className="category-nav-category-icons-wrapper">
    <img className="category-nav-category-icons-edit" onClick={onEditIconClick} src={EditIcon} alt="Edit category"/>
    {shouldShowDelete && <img className="category-nav-category-icons-delete" onClick={onDeleteIconClick} src={DeleteIcon} alt="Delete category"/>}
  </div>
)

const Chevron = ({ isCategoryOpen }) => {
  const name = isCategoryOpen ? CHEVRON_DOWN : CHEVRON_RIGHT
  return (
    <div className={cx('category-nav-category-chevron-wrapper', {
      'chevron-down-wrapper': name === CHEVRON_DOWN,
      'chevron-right-wrapper': name === CHEVRON_RIGHT
      })}
    >
      <Icon className={cx('category-nav-category-chevron', {
        'chevron-down': name === CHEVRON_DOWN,
        'chevron-right': name === CHEVRON_RIGHT
        })} name={name}
      />
    </div>
  )
}

const CategoryItem = ({provided, snapshot, onCategoryItemClick, categories, category, parsedCategoryId, onOpenSidebar, onOpenDeleteModal, shouldToggleChevron }) => {
  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      onClick={onCategoryItemClick}
      className={cx('category-nav-category', {
        'selected': (category.id === parsedCategoryId),
        'is-dragging': snapshot.isDragging
      })}
    >
      <Link
        className={cx('category-nav-item', {
          'selected': category.id === parsedCategoryId
        })}
        to={`/category/${category.id}`}
      >
        <div className="category-nav-hamburger-icon">
          <Icon name="hamburger" width="14" height="10" className="category-nav-hamburger-icoSn"/>
        </div>
        <div className="category-nav-category-name">{category.name}</div>
        <Chevron isCategoryOpen={shouldToggleChevron}/>
        <EditCategoryButtons
          shouldShowDelete={categories.length > 1}
          onEditIconClick={() => onOpenSidebar(category, 'category')}
          onDeleteIconClick={() => onOpenDeleteModal(category, 'category')}
        />
      </Link>
    </div>
  )
}

export default CategoryItem